import { useState, useEffect } from 'react';
import log from '../services/log'
import fetcher from '../services/fetcher'

function useIndicators() {
const [isLoading, setIsLoading] = useState(false)
const [indicators, setIndicators] = useState(null)

  async function getIndicators(){
      setIsLoading(true)
      const indicators = await fetcher.getIndicators()
      log.traceTag('indicators', indicators)
      if (indicators){
          setIsLoading(false)
          setIndicators(indicators)
      }
  }

  useEffect(() => {
    getIndicators()

    const timer = setInterval(() => {
        getIndicators()
    }, 60000); // update every 60 seconds

    return () => clearInterval(timer);
  }, []);

  return [indicators, isLoading];
}

export default useIndicators;